export const FERTILIZER_EVENTS_LOAD_REQUESTED =
    'FERTILIZER_EVENTS_LOAD_REQUESTED';
export const FERTILIZER_EVENTS_LOAD_SUCCEEDED =
    'FERTILIZER_EVENTS_LOAD_SUCCEEDED';
export const FERTILIZER_EVENTS_LOAD_FAILED = 'FERTILIZER_EVENTS_LOAD_FAILED';
export const FERTILIZER_EVENTS_LOAD_CANCELED =
    'FERTILIZER_EVENTS_LOAD_CANCELED';

export const FERTILIZER_EVENT_CREATE_REQUESTED =
    'FERTILIZER_EVENT_CREATE_REQUESTED';
export const FERTILIZER_EVENT_CREATE_SUCCEEDED =
    'FERTILIZER_EVENT_CREATE_SUCCEEDED';
export const FERTILIZER_EVENT_CREATE_FAILED = 'FERTILIZER_EVENT_CREATE_FAILED';

export const FERTILIZER_EVENT_UPDATE_REQUESTED =
    'FERTILIZER_EVENT_UPDATE_REQUESTED';
export const FERTILIZER_EVENT_UPDATE_SUCCEEDED =
    'FERTILIZER_EVENT_UPDATE_SUCCEEDED';
export const FERTILIZER_EVENT_UPDATE_FAILED = 'FERTILIZER_EVENT_UPDATE_FAILED';

export const FERTILIZER_EVENT_DELETE_REQUESTED =
    'FERTILIZER_EVENT_DELETE_REQUESTED';
export const FERTILIZER_EVENT_DELETE_SUCCEEDED =
    'FERTILIZER_EVENT_DELETE_SUCCEEDED';
export const FERTILIZER_EVENT_DELETE_FAILED = 'FERTILIZER_EVENT_DELETE_FAILED';

export const FERTILIZER_EVENTS_COMPLETE_REQUESTED =
    'FERTILIZER_EVENTS_COMPLETE_REQUESTED';
export const FERTILIZER_EVENTS_COMPLETE_SUCCEEDED =
    'FERTILIZER_EVENTS_COMPLETE_SUCCEEDED';
export const FERTILIZER_EVENTS_COMPLETE_FAILED =
    'FERTILIZER_EVENTS_COMPLETE_FAILED';

export const FERTILIZER_EVENT_SET = 'FERTILIZER_EVENT_SET';
export const FERTILIZER_EVENTS_SET = 'FERTILIZER_EVENTS_SET';

export const FERTILIZER_EVENTS_LOAD_NAMESPACE = 'FERTILIZER_EVENTS_LOAD';
export const FERTILIZER_EVENT_CREATE_NAMESPACE = 'FERTILIZER_EVENT_CREATE';
export const FERTILIZER_EVENT_UPDATE_NAMESPACE = 'FERTILIZER_EVENT_UPDATE';
export const FERTILIZER_EVENT_DELETE_NAMESPACE = 'FERTILIZER_EVENT_DELETE';
export const FERTILIZER_EVENTS_COMPLETE_NAMESPACE =
    'FERTILIZER_EVENTS_COMPLETE';

export const FERTILIZER_EVENTS_NAMESPACE = 'FERTILIZER_EVENTS_NAMESPACE';
export const FERTILIZER_PRODUCT_FILTER_TYPE = 'FERTILIZER_PRODUCT_FILTER_TYPE';
export const FERTILIZER_DATE_RANGE_FILTER_TYPE =
    'FERTILIZER_DATE_RANGE_FILTER_TYPE';
export const FERTILIZER_ENTITIES_FILTER_TYPE =
    'FERTILIZER_ENTITIES_FILTER_TYPE';
export const FERTILIZER_INNER_ENTITIES_FILTER_TYPE =
    'FERTILIZER_INNER_ENTITIES_FILTER_TYPE';
export const FERTILIZER_DATE_FILTER_TYPE = 'FERTILIZER_DATE_FILTER_TYPE';
